import React from 'react';
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
  Line,
} from 'recharts';

const formatCurrency = (value) => {
  if (value == null || isNaN(value)) return '$0';
  return `$${Number(value).toLocaleString()}`;
};

const formatShortCurrency = (val) => {
  if (val >= 1_000_000) return `$${(val / 1_000_000).toFixed(2)}M`;
  if (val >= 1_000) return `$${(val / 1_000).toFixed(0)}K`;
  return `$${Math.round(val)}`;
};

const BankLendingYearlyChart = ({ yearlyData }) => {
  if (!yearlyData || yearlyData.length === 0) {
    return <div className="text-center text-gray-500">No chart data available.</div>;
  }

  return (
    <div className="bg-white shadow-md rounded-lg p-6 mt-8">
      <h2 className="text-xl font-bold text-center text-blue-700 mb-6">
        Bank Lending Breakdown by Year
      </h2>

      <ResponsiveContainer width="100%" height={500}>
        <ComposedChart
          data={yearlyData}
          margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="year" />
          <YAxis tickFormatter={(value) => `$${value / 1000}k`} />
          <Tooltip formatter={(value) => formatCurrency(value)} />
          <Legend />
          <Bar dataKey="investorEquity" stackId="bank" fill="#FF6384" opacity={0.6} name="Investor Equity" />
          <Bar dataKey="entrepreneurEquity" stackId="bank" fill="#36a2eb" opacity={0.6} name="Entrepreneur Equity" />
          {/* <Bar dataKey="principalPaid" stackId="bank" fill="#93c5fd" name="Principal Paid" /> */}
          <Bar dataKey="interestPaid" stackId="bank" fill="#60a5fa" name="Interest Paid" />
          <Bar dataKey="taxPaid" stackId="bank" fill="#facc15" name="Tax Paid" />
          <Bar dataKey="insurancePaid" stackId="bank" fill="#34d399" name="Insurance Paid" />
          <Bar dataKey="maintenancePaid" stackId="bank" fill="#fbbf24" name="Maintenance Paid" />

          {/* <Line type="monotone" dataKey="investorEquity" stroke="#2563eb" strokeWidth={2} name="Investor Equity" />
          <Line type="monotone" dataKey="entrepreneurEquity" stroke="#7E22CE" strokeWidth={2} name="Entrepreneur Equity" /> */}
          <Line type="monotone" dataKey="assetValue" stroke="#0f172a" strokeWidth={2} name="Asset Value">  <LabelList
            dataKey="assetValue"
            position="top"
            content={({ x, y, value, index }) =>
              index === yearlyData.length - 1 ? (
                <text x={x - 6} y={y - 14} fill="#0f172a" textAnchor="middle" fontSize={12} fontWeight="bold">
                  Asset: {formatShortCurrency(value)}
                </text>
              ) : null
            }
          />
          </Line>

          <Line type="monotone" dataKey="investorExitValue" stroke="#2563eb" strokeWidth={2} strokeDasharray="4 2" name="Investor Exit Value">
            <LabelList
              dataKey="investorExitValue"
              position="left"
              content={({ x, y, value, index }) =>
                index === yearlyData.length - 1 ? (
                  <text x={x - 6} y={y + 14} fill="#2563eb" textAnchor="middle" fontSize={12} fontWeight="bold">
                    Invs Exit: {formatShortCurrency(value)}
                  </text>
                ) : null
              }
            />
          </Line>
          <Line type="monotone" dataKey="entrepreneurExitValue" stroke="#7E22CE" strokeWidth={2} strokeDasharray="4 2" name="Entrepreneur Exit Value">
            <LabelList
              dataKey="entrepreneurExitValue"
              position="bottom"
              content={({ x, y, value, index }) =>
                index === yearlyData.length - 1 ? (
                  <text x={x - 6} y={y + 14} fill="#7E22CE" textAnchor="middle" fontSize={12} fontWeight="bold">
                    Entr Exit: {formatShortCurrency(value)}
                  </text>
                ) : null
              }
            />

          </Line>

        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BankLendingYearlyChart;
